import Filter from "./Filter";
import FormData from "./FormData";
import ListData from "./ListData";
import NoFolder from "./NoFolder";
import TableData from "./TableData";

const foldersComponents = {
  Filter,
  FormData,
  ListData,
  NoFolder,
  TableData
}

export default foldersComponents